var _excluded = ["agent"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { AllImageSizes, getImageUrl } from '@domain-group/fe-allhomes-library';
import { AgentRecommendationsGraphQL } from '@domain-group/fe-co-allhomes-agent-recommendations';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { AllhomesListingCardGraphQL } from '@domain-group/fe-co-allhomes-listing-card';
import { AgentAwardsFragmentDoc } from './allhomes-awards.generated';
import AgentProfile from './allhomes-agent-profile';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment AgentProfile on Agent {\n    agentId\n    name\n    isPrivateLister\n    phone\n    profileUrl\n    profilePhoto\n    description\n    isEmailContactable\n    profileVideo\n    jobTitle\n    activity {\n      stats {\n        sales\n        sold\n        soldSecondary\n        rentals\n        rented\n        rentedSecondary\n        developments\n        soldDevelopments\n        soldDevelopmentsSecondary\n        saleStats {\n          daysOnMarket\n        }\n      }\n    }\n    agency {\n      agencyId\n      name\n      profileUrl\n      website\n      images {\n        tinyLogo\n      }\n      logoBackgroundColour\n      address {\n        line1\n        formattedFull\n        division {\n          name\n          slug\n        }\n        state {\n          abbrev\n        }\n        postcode\n        coordinates {\n          lat\n          lng\n        }\n      }\n    }\n    listings {\n      stats {\n        sales\n        rentals\n        sold\n        rented\n      }\n      sales: listings(type: SALES, first: $initialListings) {\n        ...ListingCard\n      }\n      rentals: listings(type: RENTALS, first: $initialListings) {\n        ...ListingCard\n      }\n      sold: listings(type: SOLD, first: $initialListings) {\n        ...ListingCard\n      }\n      rented: listings(type: RENTED, first: $initialListings) {\n        ...ListingCard\n      }\n    }\n    reviewProfile {\n      ...AgentRecommendations\n    }\n    articles(limit: 3) {\n      title\n      tags {\n        label\n      }\n      image\n      url\n    }\n    inclusions {\n      brandingLevel\n    }\n    reviewProfile {\n      reviewCount\n      overallRating\n    }\n    ...AgentAwards\n  }\n  ", "\n  ", "\n  ", "\n"])), AllhomesListingCardGraphQL.fragment, AgentRecommendationsGraphQL.fragment, AgentAwardsFragmentDoc);
var listingCardProps = listings => (listings || []).map(property => ({
  id: property.listing.id,
  url: property.listing.url,
  title: property.listing.title,
  images: {
    listingImage: property.listing.firstImage && getImageUrl(property.listing.firstImage.imageSrc, AllImageSizes.PHONE_LARGE),
    listingImageLowResolution: property.listing.firstImage && getImageUrl(property.listing.firstImage.imageSrc, AllImageSizes.SMALL)
  },
  price: property.listing.price,
  address: {
    street: property.address.line1,
    suburb: property.address.division.name,
    state: property.address.state.abbrev,
    postcode: property.address.postcode
  },
  features: {
    beds: property.features.bedrooms,
    baths: property.features.bathrooms.bathrooms,
    ensuite: property.features.bathrooms.ensuites,
    garage: property.features.parking.garages,
    carport: property.features.parking.carports,
    parking: property.features.parking.other,
    propertyType: property.features.propertyType,
    landSize: property.features.blockSize
  },
  listingBadges: {
    annotations: property.listing.annotations
  }
}));
var graphQLToProps = agent => {
  var _agent$agency$address, _agent$agency$address2, _agent$agency$address3, _agent$agency$address4, _agent$agency$address5, _agent$agency$address6, _agent$agency$address7, _agent$agency$address8, _agent$agency$address9, _agent$agency$address0, _agent$agency$images, _agent$inclusions;
  return {
    agent: {
      id: agent.agentId,
      name: agent.name,
      jobTitle: agent.jobTitle,
      videoUrl: agent.profileVideo,
      description: agent.description,
      website: agent.agency.website,
      images: {
        profilePhoto: agent.profilePhoto
      },
      address: {
        street: (_agent$agency$address = agent.agency.address) === null || _agent$agency$address === void 0 ? void 0 : _agent$agency$address.line1,
        suburb: (_agent$agency$address2 = agent.agency.address) === null || _agent$agency$address2 === void 0 ? void 0 : (_agent$agency$address3 = _agent$agency$address2.division) === null || _agent$agency$address3 === void 0 ? void 0 : _agent$agency$address3.name,
        state: (_agent$agency$address4 = agent.agency.address) === null || _agent$agency$address4 === void 0 ? void 0 : (_agent$agency$address5 = _agent$agency$address4.state) === null || _agent$agency$address5 === void 0 ? void 0 : _agent$agency$address5.abbrev,
        postcode: (_agent$agency$address6 = agent.agency.address) === null || _agent$agency$address6 === void 0 ? void 0 : _agent$agency$address6.postcode,
        lat: (_agent$agency$address7 = agent.agency.address) === null || _agent$agency$address7 === void 0 ? void 0 : (_agent$agency$address8 = _agent$agency$address7.coordinates) === null || _agent$agency$address8 === void 0 ? void 0 : _agent$agency$address8.lat,
        lng: (_agent$agency$address9 = agent.agency.address) === null || _agent$agency$address9 === void 0 ? void 0 : (_agent$agency$address0 = _agent$agency$address9.coordinates) === null || _agent$agency$address0 === void 0 ? void 0 : _agent$agency$address0.lng
      },
      phone: agent.phone,
      emailContactable: agent.isEmailContactable,
      agency: {
        id: agent.agency.agencyId,
        name: agent.agency.name,
        profileUrl: agent.agency.profileUrl,
        logoBackgroundColour: agent.agency.logoBackgroundColour,
        images: {
          logo: (_agent$agency$images = agent.agency.images) === null || _agent$agency$images === void 0 ? void 0 : _agent$agency$images.tinyLogo
        },
        address: {
          formattedFull: agent.agency.address.formattedFull
        }
      },
      stats: {
        sold: String(agent.activity.stats.sold),
        forSale: String(agent.activity.stats.sales),
        averageDays: String(agent.activity.stats.saleStats.daysOnMarket),
        rented: String(agent.activity.stats.rented),
        forRent: String(agent.activity.stats.rentals),
        soldDevelopments: String(agent.activity.stats.soldDevelopments),
        developments: String(agent.activity.stats.developments),
        soldDevelopmentsSecondary: String(agent.activity.stats.soldDevelopmentsSecondary),
        rentedSecondary: String(agent.activity.stats.rentedSecondary),
        soldSecondary: String(agent.activity.stats.soldSecondary)
      },
      oldStats: {
        sold: String(agent.listings.stats.sold),
        sales: String(agent.listings.stats.sales),
        rentals: String(agent.listings.stats.rentals)
      },
      awards: agent.awards,
      memberships: agent.memberships,
      brandingLevel: (_agent$inclusions = agent.inclusions) === null || _agent$inclusions === void 0 ? void 0 : _agent$inclusions.brandingLevel,
      reviewProfile: agent.reviewProfile
    },
    initialListings: {
      sales: {
        id: 'sales',
        listings: agent.listings.sales && listingCardProps(agent.listings.sales),
        total: agent.listings.stats.sales
      },
      rentals: {
        id: 'rentals',
        listings: agent.listings.rentals && listingCardProps(agent.listings.rentals),
        total: agent.listings.stats.rentals
      },
      recentlySold: {
        id: 'sold',
        listings: agent.listings.sold && listingCardProps(agent.listings.sold),
        total: agent.listings.stats.sold
      },
      recentlyRented: {
        id: 'rented',
        listings: agent.listings.rented && listingCardProps(agent.listings.rented),
        total: agent.listings.stats.rented
      }
    },
    reviewProfile: agent.reviewProfile,
    articles: agent.articles
  };
};
var buildBreadcrumbs = (agent, getAbsoluteUrl, _ref) => {
  var _agent$agency$address1, _agent$agency$address10;
  var breadcrumbs = _ref.breadcrumbs,
    agentsResultsUrl = _ref.agentsResultsUrl;
  return [...(breadcrumbs || []), ...((_agent$agency$address1 = agent.agency.address) !== null && _agent$agency$address1 !== void 0 && (_agent$agency$address10 = _agent$agency$address1.division) !== null && _agent$agency$address10 !== void 0 && _agent$agency$address10.slug ? [{
    text: agent.agency.address.division.name,
    link: getAbsoluteUrl("".concat(agentsResultsUrl).concat(agent.agency.address.division.slug, "/"))
  }] : []), {
    text: agent.agency.name,
    link: agent.agency.profileUrl
  }, {
    text: agent.name,
    link: ''
  }];
};
var AgentProfileGraphQL = _ref2 => {
  var agent = _ref2.agent,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX(AgentProfile, _extends({}, graphQLToProps(agent), props, {
    breadcrumbs: buildBreadcrumbs(agent, getAbsoluteUrl, _objectSpread({}, props))
  }));
};
AgentProfileGraphQL.fragment = fragment;
AgentProfileGraphQL.propTypes = {
  agent: PropTypes.shape({})
};
AgentProfileGraphQL.defaultProps = {
  agent: {}
};
export default AgentProfileGraphQL;